import { Component } from '@angular/core';

@Component({
  selector: 'app-staffsidebar',
  templateUrl: './app-staffsidebar.component.html'
})
export class AppStaffsidebarComponent { }



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/components/app-staffsidebar/app-staffsidebar.component.ts